<p-dialog header="Edit Expense Account" [(visible)]="dialogVisible" [draggable]="false" [resizable]="false" [modal]="true"
    [blockScroll]="true" appendTo="body" (onHide)="closeForm()">
    <form [formGroup]="form" (ngSubmit)="submit()">

        <div class="formgrid grid">
            <div class="field col-12">
                <label for="name">Name</label>
                <input id="name" type="text" #focusElement pInputText formControlName="name" class="inputfield w-full" />
                <app-validation-messages [control]="form.get('name')!" label="Name"></app-validation-messages>
            </div>
            <div class="field col-12">
                <label for="name">Budget</label>
                <input id="name" type="number" pInputText formControlName="budget" class="inputfield w-full" />
                <app-validation-messages [control]="form.get('budget')!" label="Budget"></app-validation-messages>
            </div>
            <div class="field col-12" *ngIf="shouldShowPrivateOption | async">
                <p-checkbox name="privateAccountGroup" [binary]="true" label="Make Private" formControlName="isPrivate" class="inputfield w-full"></p-checkbox>
            </div>
        </div>

    </form>
    <ng-template pTemplate="footer">
        <form [formGroup]="form" (ngSubmit)="submit()">
            <button pButton type="submit" icon="pi pi-save" [disabled]="!form.valid" label="Save" class="p-button-success"></button>
            <button pButton type="button" icon="pi pi-times" label="Cancel" class="p-button-secondary"
                (click)="closeForm()"></button>
        </form>
    </ng-template>
</p-dialog>
